<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar a ferramenta <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(oil) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_OIL_MUTATION,
          variables: {
            id: oil.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyTool.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_OIL_MUTATION = gql `
  mutation($id: ID!) {
    destroyTool(id: $id) {
      item {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>